/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useState} from 'react'
import { useToast } from "../../../../../../../../../../../components/Toats";
import { getTypeServicesAll } from "../../../../../../../../../../../../services/typeServices";
import { getProductsAll } from "../../../../../../../../../../../../services/productsService";
import { getFile } from "../../../../../../../../../../../../services/files";
import { Loading } from '../../../../../../../../../../../components/Loadings/loading';
import { SelectGlobal } from '../../../../../../../../../../../components/SelectGlobal';


const SERVICE_FALLBACK_ICON = '/media/icons/duotune/general/gen016.svg'
const PRODUCT_FALLBACK_ICON = '/media/icons/duotune/ecommerce/ecm003.svg'

const resolveItemImage = async (imageKey?: string | null) => {
  if (!imageKey) return null

  try {
    const response = await getFile(imageKey)
    return response?.url || null
  } catch {
    return null
  }
}

const mapServiceOptions = async (services: any[]) => {
  return Promise.all(
    (services || []).map(async (service) => {
      const imageUrl = await resolveItemImage(service.image)
      return {
        ...service,
        label: service.description || 'Serviço sem nome',
        link_imagem: imageUrl || SERVICE_FALLBACK_ICON,
        linkIcon: imageUrl || SERVICE_FALLBACK_ICON,
      }
    })
  )
}

const mapProductOptions = async (products: any[]) => {
  return Promise.all(
    (products || []).map(async (product) => {
      const imageUrl = await resolveItemImage(product.image)
      return {
        ...product,
        label: product.name || product.description || 'Produto sem nome',
        link_imagem: imageUrl || PRODUCT_FALLBACK_ICON,
        linkIcon: imageUrl || PRODUCT_FALLBACK_ICON,
      }
    })
  )
}

const StepModal = ({hasError, formik, setTypeServicesRaiz, setProductsRaiz}: any) => {
  const [typeServices, setTypeServices] = useState<any[]>([])
  const [products, setProducts] = useState<any[]>([])
  const [loadingTypeServices, setLoadingTypeServices] = useState(false)
  const [loadingProducts, setLoadingProducts] = useState(false)
  const {toggleToast} = useToast()

  const getTypeServices = async () => {
    try {
      setLoadingTypeServices(true)
      const myTypeServices = await getTypeServicesAll()
      const mappedServices = await mapServiceOptions(myTypeServices)
      setTypeServices(mappedServices)
      setTypeServicesRaiz(myTypeServices)
    } catch (error) {
      console.log(error)
      toggleToast('Erro ao buscar a lista de serviços prestados. ', 'error')
    } finally {
      setLoadingTypeServices(false)
    }
  }

  const getProducts = async () => {
    try {
      setLoadingProducts(true)
      const myProducts = await getProductsAll()
      const mappedProducts = await mapProductOptions(myProducts)
      setProducts(mappedProducts)
      setProductsRaiz(myProducts)
    } catch (error) {
      console.log(error)
      toggleToast('Erro ao buscar a lista de produtos da empresa. ', 'error')
    } finally {
      setLoadingProducts(false)
    }
  }

  useEffect(() => {
    getTypeServices()
    getProducts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loadingTypeServices || loadingProducts) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          height: '15rem',
          alignItems: 'center',
        }}
      >
        <Loading myClass='spinner-border' style={{width: '3rem', height: '3rem'}} />
      </div>
    )
  }

  return (
    <div className='current' data-kt-stepper-element='content'>
      <div className='w-100'>
        <div style={{display: 'flex', gap: '1rem'}}>
          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Tipo de Item</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Selecione o serviço. '
              ></i>
            </label>
            <div>
              <select
                className='form-select form-select-solid'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                value={formik.values.tipo ? formik.values.tipo : ''}
                onChange={(event) => {
                  const nextTipo = event.target.value
                  formik.setFieldValue('tipo', nextTipo)
                  formik.setFieldValue('idTypeService', null)
                  formik.setFieldValue('idProduct', null)
                }}
              >
                <option value={''}></option>
                <option value={'SERVICO'}>Serviço</option>
                <option value={'PRODUTO'}>Produto</option>
              </select>
            </div>
          </div>
        </div>

        {formik.values.tipo === 'SERVICO' && (
          <div style={{display: 'flex', gap: '1rem'}}>
            <div className='fv-row mb-10' style={{flex: '1'}}>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Serviço</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Selecione o serviço. '
                ></i>
              </label>
              <SelectGlobal
                itens={typeServices}
                buttonAll={false}
                textSearch='Buscar serviço'
                textButtonInit='Selecione o serviço'
                labelKey='label'
                valueKey='id'
                typeIcon='img'
                imageSize='35px'
                linkIcon={SERVICE_FALLBACK_ICON}
                value={formik.values.idTypeService || ''}
                loading={loadingTypeServices}
                onChange={(value: string) => {
                  formik.setFieldValue('idTypeService', value || null)
                  const selected = typeServices.find((item) => item.id === value)
                  if (selected?.preco != null) {
                    formik.setFieldValue('value', selected.preco)
                  }
                  if ((selected?.details || selected?.description) && !formik.values.description) {
                    formik.setFieldValue(
                      'description',
                      selected.details || selected.description
                    )
                  }
                }}
              />
              {!formik.values.idTypeService && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Selecione o serviço!
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {formik.values.tipo === 'PRODUTO' && (
          <div style={{display: 'flex', gap: '1rem'}}>
            <div className='fv-row mb-10' style={{flex: '1'}}>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Produto</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Selecione o produto. '
                ></i>
              </label>
              <SelectGlobal
                itens={products}
                buttonAll={false}
                textSearch='Buscar produto'
                textButtonInit='Selecione o produto'
                labelKey='label'
                valueKey='id'
                typeIcon='img'
                imageSize='35px'
                linkIcon={PRODUCT_FALLBACK_ICON}
                value={formik.values.idProduct || ''}
                loading={loadingProducts}
                onChange={(value: string) => {
                  formik.setFieldValue('idProduct', value || null)
                  const selected = products.find((item) => item.id === value)
                  if (selected?.preco != null) {
                    formik.setFieldValue('value', selected.preco)
                  }
                  if ((selected?.name || selected?.description) && !formik.values.description) {
                    formik.setFieldValue(
                      'description',
                      selected.description || selected.name
                    )
                  }
                }}
              />
              {!formik.values.idProduct && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Selecione o produto!
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        <div>
          <div className='fv-row mb-10' style={{flex: '1'}}>
            <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
              <span>Descrição</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Descreva com mais detalhes o serviço'
              ></i>
            </label>
            <input
              style={{height: '20rem'}}
              type='text'
              className='form-control form-control-lg'
              name='description'
              placeholder=''
              value={formik.values.description ? formik.values.description : ''}
              onChange={formik.handleChange('description')}
            />
          </div>

          <div style={{display: 'flex', gap: '1rem'}}>
            <div className='fv-row mb-10' style={{flex: '1'}}>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Quantidade</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Digite um nome para a unidade(filial)'
                ></i>
              </label>
              <input
                type='number'
                className='form-control form-control-lg form-control-solid'
                name='amount'
                placeholder=''
                value={formik.values.amount}
                onChange={formik.handleChange('amount')}
              />
              {!formik.values.companyName && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Informe uma quantidade!
                  </div>
                </div>
              )}
            </div>

            <div className='fv-row mb-10' style={{flex: '1'}}>
              <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                <span className='required'>Preço</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Digite um preço para o serviço. '
                ></i>
              </label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid'
                name='value'
                placeholder=''
                value={formik.values.value}
                onChange={formik.handleChange('value')}
              />
              {!formik.values.companyName && hasError && (
                <div className='fv-plugins-message-container'>
                  <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                    Informe um preço.
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {StepModal}
